import minDifferenceInYearsBetweenDates from './minDifferenceInYearsBetweenDates'

export default endDate => value => {
  return minDifferenceInYearsBetweenDates(value, endDate, 2)
}
